/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';

import PropTypes from 'prop-types';

import '../../styles/input/input-field.scss';

const InputField = (props) => {
  const { label, name, warning, onChange,
    value, type, max, password, placeholder, autoComplete, onBlur, disabled } = props;
  const id = `${name}-${Math.floor(Math.random() * 1000)}`;
  const onTextChange = (e) => {
    const targetValue = name === 'email' ? e.target.value.trim() : e.target.value;
    onChange({ [name]: targetValue });
    e.persist();
  };
  const [showPassword, setShowPassword] = useState(password);
  return (
    <div className={`input-fieldRoot ${warning ? 'warning' : 'no-warning'} ${disabled ? 'disabled' : ''}`}>
      {type === 'text' && (
        <>
          {password && (
          <a
            className="password-show-btn"
            onClick={() => setShowPassword(!showPassword)}
            role="presentation"
          >
            {showPassword ? 'Show' : 'Hide'}
          </a>
          )}
          <input
            aria-invalid="false"
            id={id}
            placeholder={placeholder}
            autoComplete={autoComplete}
            type={!showPassword ? 'text' : 'password'}
            value={value}
            name={name}
            maxLength={max}
            onChange={(e) => onTextChange(e)}
            onBlur={onBlur}
            disabled={disabled}
          />
        </>
      )}
      {type === 'textarea' && (
        <textarea
          aria-invalid="false"
          id={id}
          placeholder={placeholder}
          rows="3"
          type="text"
          autoComplete={autoComplete}
          name={name}
          maxLength={max}
          onChange={(e) => onTextChange(e)}
          onBlur={onBlur}
        >
          {value}
        </textarea>
      )}
      {disabled ? '' : <label className="" data-shrink="false" htmlFor={id} id={`${id}-label`}>{label}</label>}
    </div>
  );
};
InputField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  warning: PropTypes.bool,
  type: PropTypes.string,
  autoComplete: PropTypes.string,
  max: PropTypes.number,
  password: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool
};
InputField.defaultProps = {
  label: '',
  name: '',
  max: 5000,
  warning: false,
  value: '',
  autoComplete: '',
  type: 'text',
  password: false,
  placeholder: ' ',
  onChange: () => { },
  onBlur: () => { },
  disabled: false
};
export default InputField;
